import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

// Component
import AppointmentPage from './AppointmentPage';

// Actions
import {
  getFirstAvailability,
  getAvailableTimesByDates
} from 'store/reducers/availableTimes/actions';
import { goTo } from 'store/reducers/navigation/actions';
import { getApptAdvisorsAndTranspOptions } from 'store/reducers/apptOptions/actions';
import {
  gtmUserEvent,
  gtmUserEventDefaultDateSelected
} from 'store/reducers/gtm/actions';
import {
  sendShiftServiceApptShown,
  setStartTime
} from 'store/reducers/appointment/actions';
import {
  setGtmFirstAvailableTimeslot,
  setAppointmentSelectedDay,
  setNoLongerAvailableDate,
  setLastTimeslotSelected,
  dateApptPickerTouchByUser
} from 'store/reducers/userInteractions/actions';
import { setFirstAvailableTimeSlot } from 'store/reducers/firstAvailableTimeSlot/actions';
import { cleanDayTimeError } from 'store/reducers/errors/actions';

// Selectors
import {
  getStartTime,
  getTransportationOption,
  getVehicle
} from 'store/reducers/appointment/selectors';
import { getFirstAvailableTimeSlot } from 'store/reducers/firstAvailableTimeSlot/selectors';
import {
  getGtmFirstAvailableTimeslot,
  getNoLongerAvailableDate,
  getLastTimeslotSelected,
  getAppFlow,
  getSelectedTimeslotInPromoRange
} from 'store/reducers/userInteractions/selectors';
import { getActivePromotion } from 'store/reducers/promotions/selectors';
import {
  getFilteredAvailableDays,
  getAvailableDays
} from 'store/reducers/availableTimes/selectors';
import { currentPath, previousPath } from 'store/reducers/navigation/selectors';
import { errorLoadingAdvisors } from 'store/reducers/errors/selectors';
import {
  getCTABanner,
  showProgressBar,
  hideBottomCTA,
  getBackButton
} from 'store/reducers/optimizelyABTest/selectors';
import {
  getExternalValetProvider,
  isValetOrLoanerIntegration
} from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => {
  return {
    startTime: getStartTime(state),
    firstAvailableTimeSlot: getFirstAvailableTimeSlot(state),
    gtmFirstAvailableTimeslot: getGtmFirstAvailableTimeslot(state),
    promotion: getActivePromotion(state),
    selectedTransportation: getTransportationOption(state),
    noLongerAvailableDate: getNoLongerAvailableDate(state),
    lastTimeslotSelected: getLastTimeslotSelected(state),
    filteredAvailableDays: getFilteredAvailableDays(state),
    currentPath: currentPath(state),
    previousPath: previousPath(state),
    noAdvisorsError: errorLoadingAdvisors(state),
    appFlow: getAppFlow(state),
    ctaBanner: getCTABanner(state),
    vehicle: getVehicle(state),
    showProgressBar: showProgressBar(state),
    hideBottomCTA: hideBottomCTA(state),
    ctaBackButton: getBackButton(state),
    externalProvider: getExternalValetProvider(state),
    availableDays: getAvailableDays(state),
    isValetOrLoanerIntegration: isValetOrLoanerIntegration(state),
    selectedTimeslotInPromoRange: getSelectedTimeslotInPromoRange(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getFirstAvailability,
      getAvailableTimesByDates,
      goTo,
      setGtmFirstAvailableTimeslot,
      gtmUserEventDefaultDateSelected,
      setAppointmentSelectedDay,
      getApptAdvisorsAndTranspOptions,
      setNoLongerAvailableDate,
      setLastTimeslotSelected,
      setStartTime,
      gtmUserEvent,
      setFirstAvailableTimeSlot,
      cleanDayTimeError,
      sendShiftServiceApptShown,
      dateApptPickerTouchByUser
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AppointmentPage);



// WEBPACK FOOTER //
// ./src/components/pages/AppointmentPage/AppointmentContainerPage.js